
import _ from '@/lib/lodash';

export default {
  i18nComponentKey: 'WidgetProductReviewsStatistics.components.BarChart',
  name: 'BarChart',
  props: {
    data: { type: Array, default: () => [] },
    highlightStatisticalResults: { type: Boolean, default: false }
  },
  computed: {
    sumOfPercentages() {
      return _.sumBy(this.data, 'percentage');
    }
  },
  mounted() {
    this.resizeNameColumnWidth();
  },
  methods: {
    displayPercent: percentage =>
      Number.isInteger(percentage) ? percentage : 0,
    resizeNameColumnWidth() {
      const nameColumnElements = this.$refs.nameColumns;
      const widestElement = _.maxBy(nameColumnElements, 'offsetWidth');
      for (const nameColumnElement of nameColumnElements) {
        nameColumnElement.style.width = `${widestElement.offsetWidth}px`;
      }
    },
    isLargest(index) {
      if (this.sumOfPercentages === 0) return false;
      return index === _.indexOf(this.data, _.maxBy(this.data, 'percentage'));
    }
  }
};
